
import { Component, Prop, Vue } from 'vue-property-decorator'

import { MultiChoiceCard, DotationOperation } from '@/models'
import { extractApiErrorMessages } from '@/utils/apiErrors'
import { getBulkRevokeDescriptionKey } from '@/utils/revokeDialog'

@Component({
  name: 'RevokeMultiChoiceCardsDialog'
})
export default class extends Vue {
  @Prop({ required: true }) private visible!: boolean
  @Prop({ required: true }) private cards!: MultiChoiceCard[]
  @Prop({ required: true }) private operation!: DotationOperation

  private loading = false

  get emailWarningKey(): string {
    return 'gifts.revokeBulkDialog.emailWarning'
  }

  get descriptionKey(): string {
    return getBulkRevokeDescriptionKey(this.cards, this.operation.preIssue)
  }

  private notifyErrors(err: any): void {
    const messages = extractApiErrorMessages(err)
    const fallback = String(this.$t('gifts.revokeBulkDialog.notification.error.fallback'))
    const toDisplay = messages.length > 0 ? messages : [fallback]

    for (const message of toDisplay) {
      this.$notify({
        title: String(this.$t('gifts.revokeBulkDialog.notification.error.title')),
        message,
        type: 'error',
        duration: 5000
      })
    }
  }

  get totalAmount(): number {
    return this.cards.reduce((sum, card) => sum + (card.amount || 0), 0)
  }

  get hasAnyEmailSent(): boolean {
    return this.cards.some(card => card.hasDeliveryEmailBeenSent)
  }

  async submit() {
    this.loading = true
    try {
      await this.operation.revokes(this.cards.map(card => card.id))
      this.$notify({
        title: String(this.$t('gifts.revokeBulkDialog.notification.success.title')),
        message: String(this.$t('gifts.revokeBulkDialog.notification.success.message', { count: this.cards.length })),
        type: 'success',
        duration: 2000
      })
      this.$emit('revoked')
      this.$emit('close')
    } catch (err: any) {
      this.notifyErrors(err)
    } finally {
      this.loading = false
    }
  }
}
